// Generated by purs version 0.15.15
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Codec from "../Data.Codec/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Visonum_API_SpeedMaster from "../Visonum.API.SpeedMaster/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var fromHomogeneous = /* #__PURE__ */ Foreign_Object.fromHomogeneous();
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var LoginNotTried = /* #__PURE__ */ (function () {
    function LoginNotTried() {

    };
    LoginNotTried.value = new LoginNotTried();
    return LoginNotTried;
})();
var LoginChecking = /* #__PURE__ */ (function () {
    function LoginChecking() {

    };
    LoginChecking.value = new LoginChecking();
    return LoginChecking;
})();
var LoginSuccess = /* #__PURE__ */ (function () {
    function LoginSuccess() {

    };
    LoginSuccess.value = new LoginSuccess();
    return LoginSuccess;
})();
var LoginFailure = /* #__PURE__ */ (function () {
    function LoginFailure() {

    };
    LoginFailure.value = new LoginFailure();
    return LoginFailure;
})();
var DownloadCsv = /* #__PURE__ */ (function () {
    function DownloadCsv() {

    };
    DownloadCsv.value = new DownloadCsv();
    return DownloadCsv;
})();
var DownloadJson = /* #__PURE__ */ (function () {
    function DownloadJson() {

    };
    DownloadJson.value = new DownloadJson();
    return DownloadJson;
})();
var Initialize = /* #__PURE__ */ (function () {
    function Initialize() {

    };
    Initialize.value = new Initialize();
    return Initialize;
})();
var Finalize = /* #__PURE__ */ (function () {
    function Finalize() {

    };
    Finalize.value = new Finalize();
    return Finalize;
})();
var ShowDetails = /* #__PURE__ */ (function () {
    function ShowDetails(value0) {
        this.value0 = value0;
    };
    ShowDetails.create = function (value0) {
        return new ShowDetails(value0);
    };
    return ShowDetails;
})();
var HideDetails = /* #__PURE__ */ (function () {
    function HideDetails() {

    };
    HideDetails.value = new HideDetails();
    return HideDetails;
})();
var DownloadResults = /* #__PURE__ */ (function () {
    function DownloadResults(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    DownloadResults.create = function (value0) {
        return function (value1) {
            return new DownloadResults(value0, value1);
        };
    };
    return DownloadResults;
})();
var UpdateJobInput = /* #__PURE__ */ (function () {
    function UpdateJobInput(value0) {
        this.value0 = value0;
    };
    UpdateJobInput.create = function (value0) {
        return new UpdateJobInput(value0);
    };
    return UpdateJobInput;
})();
var SetShowNewJob = /* #__PURE__ */ (function () {
    function SetShowNewJob(value0) {
        this.value0 = value0;
    };
    SetShowNewJob.create = function (value0) {
        return new SetShowNewJob(value0);
    };
    return SetShowNewJob;
})();
var SubmitNewJob = /* #__PURE__ */ (function () {
    function SubmitNewJob() {

    };
    SubmitNewJob.value = new SubmitNewJob();
    return SubmitNewJob;
})();
var SetPassword = /* #__PURE__ */ (function () {
    function SetPassword(value0) {
        this.value0 = value0;
    };
    SetPassword.create = function (value0) {
        return new SetPassword(value0);
    };
    return SetPassword;
})();
var CancelJob = /* #__PURE__ */ (function () {
    function CancelJob(value0) {
        this.value0 = value0;
    };
    CancelJob.create = function (value0) {
        return new CancelJob(value0);
    };
    return CancelJob;
})();
var HideError = /* #__PURE__ */ (function () {
    function HideError() {

    };
    HideError.value = new HideError();
    return HideError;
})();
var Login = /* #__PURE__ */ (function () {
    function Login() {

    };
    Login.value = new Login();
    return Login;
})();
var Logout = /* #__PURE__ */ (function () {
    function Logout() {

    };
    Logout.value = new Logout();
    return Logout;
})();
var genericLogInState_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return LoginNotTried.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return LoginChecking.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return LoginSuccess.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return LoginFailure.value;
        };
        throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App.Types (line 83, column 1 - line 83, column 37): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof LoginNotTried) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof LoginChecking) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof LoginSuccess) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof LoginFailure) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App.Types (line 83, column 1 - line 83, column 37): " + [ x.constructor.name ]);
    }
};
var showLogInState = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericLogInState_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "LoginNotTried";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "LoginChecking";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "LoginSuccess";
        }
    }))(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "LoginFailure";
        }
    })))))
};
var eqLogInState = {
    eq: function (x) {
        return function (y) {
            if (x instanceof LoginNotTried && y instanceof LoginNotTried) {
                return true;
            };
            if (x instanceof LoginChecking && y instanceof LoginChecking) {
                return true;
            };
            if (x instanceof LoginSuccess && y instanceof LoginSuccess) {
                return true;
            };
            if (x instanceof LoginFailure && y instanceof LoginFailure) {
                return true;
            };
            return false;
        };
    }
};
var parseInputVals = function (vals) {
    var obj = Data_Argonaut_Core.fromObject(fromHomogeneous({
        destinationIps: Data_Argonaut_Core.fromArray(map(Data_Argonaut_Core.fromString)(map(Data_String_Common.trim)(Data_String_Common.split("\x0a")(Data_String_Common.trim(vals.destinationIps))))),
        config: Data_Argonaut_Core.fromObject(fromHomogeneous({
            agentUrl: Data_Argonaut_Core.fromString(vals.agentUrl),
            pingCountPerIp: Data_Maybe.maybe(Data_Argonaut_Core.jsonNull)(Data_Argonaut_Core.fromNumber)(Data_Number.fromString(vals.pingCountPerIp)),
            intervalBetweenIpsMillis: Data_Maybe.maybe(Data_Argonaut_Core.jsonNull)(Data_Argonaut_Core.fromNumber)(Data_Number.fromString(vals.intervalBetweenIpsMillis)),
            intervalBetweenPingsMillis: Data_Maybe.maybe(Data_Argonaut_Core.jsonNull)(Data_Argonaut_Core.fromNumber)(Data_Number.fromString(vals.intervalBetweenPingsMillis)),
            useIcmp: Data_Argonaut_Core.fromBoolean(vals.useIcmp),
            useSynToPort: (function () {
                if (vals.useSyn) {
                    return Data_Maybe.maybe(Data_Argonaut_Core.jsonNull)(Data_Argonaut_Core.fromNumber)(Data_Number.fromString(vals.synPort));
                };
                return Data_Argonaut_Core.jsonNull;
            })()
        }))
    }));
    return Data_Codec.decode(Visonum_API_SpeedMaster.codecBulkPingStartRequest)(obj);
};
export {
    Initialize,
    Finalize,
    ShowDetails,
    HideDetails,
    DownloadResults,
    UpdateJobInput,
    SetShowNewJob,
    SubmitNewJob,
    SetPassword,
    CancelJob,
    HideError,
    Login,
    Logout,
    DownloadCsv,
    DownloadJson,
    LoginNotTried,
    LoginChecking,
    LoginSuccess,
    LoginFailure,
    parseInputVals,
    genericLogInState_,
    eqLogInState,
    showLogInState
};
//# sourceMappingURL=index.js.map
